import ScriptureDigController from './scripture_dig_controller'

export default class extends ScriptureDigController {}
